import { useEffect, useState } from "react";
import { sanityClient } from "../lib/sanity";

const HOURS_GRACE = 3;

const EVENTS_QUERY = `*[_type == "event" && dateTime(date + "T23:59:59Z") >= dateTime(now()) - 60*60*24*2] | order(date asc)[0...30]{
  _id,
  title,
  date,
  hora,
  lugar,
  description,
  image
}`;

function eventExpiresAtMs(ev) {
  if (!ev?.date) return 0;
  const [year, month, day] = ev.date.split("-").map(Number);
  if (!year || !month || !day) return 0;

  const horaMatch = (ev.hora || "").match(/(\d{1,2}):(\d{2})/);
  let h = 23;
  let m = 59;
  if (horaMatch) {
    h = parseInt(horaMatch[1], 10);
    m = parseInt(horaMatch[2], 10);
  }

  const start = new Date(year, month - 1, day, h, m, 0, 0);
  return start.getTime() + HOURS_GRACE * 60 * 60 * 1000;
}

function filterActive(events) {
  const nowMs = Date.now();
  return events.filter((ev) => eventExpiresAtMs(ev) >= nowMs);
}

export function useEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    sanityClient
      .fetch(EVENTS_QUERY)
      .then((data) => {
        if (!cancelled) {
          const list = Array.isArray(data) ? data : [];
          setEvents(filterActive(list));
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { events, loading, error };
}
